import { useState } from 'react';
import { Form } from 'react-bootstrap';
import Style from '../index.module.css';
import { FlyttEnheterTilKjedeCommand } from 'services/KjederegisteretAdminApi/EnheterBulkApi/types';
import { NorwegianDatepicker } from 'components/NorwegianDatepicker';
import MarkedsKjedePicker from 'components/MarkedsKjedePicker';
import RegionalkjedePicker from 'components/RegionalkjedePicker';
import { PickedKjede, PickerMode } from 'components/KjedePicker';

type KjedeTypeValg = 'marked' | 'regional';

interface Props {
  command: FlyttEnheterTilKjedeCommand;
  onCommandUpdated: (command: FlyttEnheterTilKjedeCommand) => void;
}

const FlyttEnheterTilKjedeForm = (props: Props) => {
  const [kjedeType, setKjedeType] = useState<KjedeTypeValg>('marked');
  const [selectedKjedeName, setSelectedKjedeName] = useState<string>('');

  const handleFraOgMedChanged = (fraOgMed: Date) => {
    props.onCommandUpdated({
      ...props.command,
      fraOgMed: fraOgMed,
    });
  };

  const handleKjedeSelected = (kjeder: PickedKjede[]) => {
    if (kjeder.length > 0) {
      const valgtKjede = kjeder[0];
      setSelectedKjedeName(valgtKjede.name);
      props.onCommandUpdated({
        ...props.command,
        kjedeNummer: Number(valgtKjede.kjedenr),
      });
    } else {
      setSelectedKjedeName('');
      props.onCommandUpdated({
        ...props.command,
        kjedeNummer: 0,
      });
    }
  };

  const handleKjedeTypeChange = (type: KjedeTypeValg) => {
    setKjedeType(type);
    // Nullstill valgt kjede ved bytte av type
    setSelectedKjedeName('');
    props.onCommandUpdated({
      ...props.command,
      kjedeNummer: 0,
    });
  };

  const toggleOverforKjedenummer = (overforKundenummer: boolean) => {
    props.onCommandUpdated({
      ...props.command,
      overforKundenummer: overforKundenummer,
    });
  };

  return (
    <>
      <Form.Group className={Style.formGroup}>
        <Form.Label>Fra og med dato</Form.Label>
        <NorwegianDatepicker
          value={props.command.fraOgMed}
          onChange={(value) => handleFraOgMedChanged(value)}
          showFirstDaySuggestions
        />
      </Form.Group>
      <Form.Group className={Style.formGroup}>
        <Form.Label className={Style.secondLabel}>Kjedetype</Form.Label>
        <Form.Select
          value={kjedeType}
          onChange={(e) => handleKjedeTypeChange(e.target.value as KjedeTypeValg)}
        >
          <option value="marked">Markedskjede</option>
          <option value="regional">Regionalkjede</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className={Style.formGroup}>
        <Form.Label className={Style.secondLabel}>Velg kjede</Form.Label>
        {kjedeType === 'marked' ? (
          <MarkedsKjedePicker
            pickerMode={PickerMode.Single}
            onSelectionChanged={handleKjedeSelected}
            selected={props.command.kjedeNummer ? [props.command.kjedeNummer] : []}
          />
        ) : (
          <RegionalkjedePicker
            pickerMode={PickerMode.Single}
            onSelectionChanged={handleKjedeSelected}
            selected={props.command.kjedeNummer ? [props.command.kjedeNummer] : []}
          />
        )}
        {selectedKjedeName && (
          <Form.Text className="text-muted">
            Valgt: {selectedKjedeName} (kjedenr: {props.command.kjedeNummer})
          </Form.Text>
        )}
        <div className={Style.checkbox}>
          <Form.Check
            checked={props.command.overforKundenummer}
            onChange={(e) => toggleOverforKjedenummer(!props.command.overforKundenummer)}
          />
          <Form.Label>Overfør kundenummere?</Form.Label>
        </div>
      </Form.Group>
    </>
  );
};

export default FlyttEnheterTilKjedeForm;
